"use client";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

interface BearerFormProps {
  config: Record<string, unknown>;
  onChange: (config: Record<string, unknown>) => void;
}

export function BearerForm({ config, onChange }: BearerFormProps) {
  const [showToken, setShowToken] = useState(false);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-white/80">Bearer Token</Label>
        <div className="relative">
          <Input
            type={showToken ? "text" : "password"}
            value={(config.token as string) || ""}
            onChange={(e) => onChange({ token: e.target.value })}
            placeholder="Enter your bearer token"
            className="border-white/10 bg-white/5 pr-10 text-white placeholder:text-white/40"
          />
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="absolute right-1 top-1/2 h-8 w-8 -translate-y-1/2 text-white/40 hover:text-white"
            onClick={() => setShowToken(!showToken)}
          >
            {showToken ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </Button>
        </div>
        <p className="text-xs text-white/40">
          Will be sent as: Authorization: Bearer {"<token>"}
        </p>
      </div>

      <div className="space-y-2">
        <Label className="text-white/80">Token Prefix (Optional)</Label>
        <Input
          value={(config.token_prefix as string) || "Bearer"}
          onChange={(e) => onChange({ token_prefix: e.target.value })}
          placeholder="Bearer"
          className="border-white/10 bg-white/5 text-white placeholder:text-white/40"
        />
        <p className="text-xs text-white/40">
          Change if the API expects a different prefix (e.g., "Token", "JWT")
        </p>
      </div>
    </div>
  );
}
